import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { client } from '@/sanity/client';

export const CallToAction = () => {
	const navigate = useNavigate();
	const [serviceSlug, setServiceSlug] = useState<string | null>(null);
	const consultationServiceId = '7c020c4f-3eaf-4b59-9ecb-3655b9d5d5a2';

	useEffect(() => {
		// Fetch the slug for the consultation service
		const fetchServiceSlug = async () => {
			try {
				const service = await client.fetch(
					`*[_id == $id][0]{
                        "slug": slug.current
                    }`,
					{ id: consultationServiceId },
				);

				if (service && service.slug) {
					setServiceSlug(service.slug);
				}
			} catch (error) {
				console.error('Error fetching consultation service:', error);
			}
		};

		fetchServiceSlug();
	}, []);

	const handleClick = () => {
		if (serviceSlug) {
			navigate(`/services/${serviceSlug}`);
		} else {
			// Fallback to services page if we couldn't get the specific slug
			navigate('/services');
		}
	};

	return (
		<section className='bg-[#fbb040] flex flex-col items-center justify-center mt-32 mx-3 px-[70px] py-[88px] max-md:max-w-full max-md:mr-2.5 max-md:mt-10 max-md:px-5 rounded-t-3xl'>
			<div className='flex w-full max-w-[1328px] items-center gap-[40px_100px] justify-between flex-wrap max-md:max-w-full md:px-25'>
				<div className='self-stretch min-w-60 w-[424px] my-auto max-md:max-w-full'>
					<h2 className='text-neutral-800 text-5xl font-bold leading-none max-md:max-w-full max-md:text-[40px]'>
						Begin your legacy
					</h2>
					<p className='text-[rgba(34,34,34,1)] text-2xl font-medium mt-4 max-md:max-w-full'>
						Book your first consultation!
					</p>
				</div>
				<button
					onClick={handleClick}
					className='bg-white self-stretch flex min-w-60 items-center gap-6 text-base text-neutral-800 font-extrabold text-center leading-none my-auto pl-6 pr-2 py-2 rounded-[100px] max-md:pl-5 hover:bg-gray-50 transition-colors'
				>
					<span>Book a consultation</span>
					<div className='bg-[#FBB040] rounded-full w-12 h-12 flex items-center justify-center'>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='18'
							height='18'
							viewBox='0 0 24 24'
							fill='none'
							stroke='currentColor'
							strokeWidth='3'
							strokeLinecap='round'
							strokeLinejoin='round'
						>
							<path d='M5 12h14M12 5l7 7-7 7' />
						</svg>
					</div>
				</button>
			</div>
		</section>
	);
};
